// extracted by mini-css-extract-plugin
module.exports = {"checkboxdiv":"checkboox_checkboxdiv__2_Tp_","text":"checkboox_text__1M0v-"};